module.exports = __webpack_public_path__ + "static/img/biaozhun_1.700fc05.png";


//////////////////
// WEBPACK FOOTER
// ./static/officeImg/index/biaozhun_1.png
// module id = KaoP
// module chunks = 1